import './LibraryItem.scss'
import './LibraryFinishedItem.scss'
import {IoMdRibbon} from "react-icons/io";
import {Link} from "react-router-dom";
import {Trans} from "react-i18next/icu.macro";
import {useTranslation} from "react-i18next";
export default function LibraryFinishedItem() {
    const { t, i18n } = useTranslation();
    let className = ['library-item', 'finished-course-item', 'current']

    return <div id="recommended-category" className={className.join(' ')}>
        <div className="library-item-info">
            <IoMdRibbon className="ribbon" />
            <h1>{t('courseCompleted.title')}</h1>
            <p>
                <Trans i18nKey="courseCompleted.text1" components={[ <Link to={"/simulation"} />]} />
                <br />
                {t('courseCompleted.text2')}
            </p>
        </div>
    </div>
}